import { HttpClient, HttpContextToken, HttpHandler } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigurableHttpClient as CoreConfigurableHttpClient } from '@corelabs/angular/core';
import { ADD_ASSETS_PREFIX, SKIP_LANGUAGE } from '../http-context';

declare module '@angular/common/http' {
    export interface HttpClient {
        addAssetsPrefix(): HttpClient;
        skipLanguage(): HttpClient;
    }
}

class ConfigurableHttpClient extends CoreConfigurableHttpClient {
    override addAssetsPrefix(): HttpClient {
        return this.with(ADD_ASSETS_PREFIX);
    }

    override skipLanguage(): HttpClient {
        return this.with(SKIP_LANGUAGE);
    }

    protected override clone(tokens: ReadonlySet<HttpContextToken<boolean>>): ConfigurableHttpClient {
        return new ConfigurableHttpClient(this.httpHandler, tokens);
    }
}

@Injectable()
export class HttpService extends ConfigurableHttpClient {
    constructor() {
        super(inject(HttpHandler), new Set());
    }
}
